<template>
    <el-dialog :visible="openDialog"
               :close-on-click-modal="false"
               :close-on-press-escape="!processing"
               :show-close="!processing"
               @close="$emit('update:openDialog', false)"
               :title="(eraseModeOn ? 'Remove' : 'Add') + ' Zip Code Radius'">

        <el-form :model="formData">
            <el-form-item label="Zip code">
                <el-input type="text"
                          :disabled="processing"
                          v-model="formData.zipCode"/>
            </el-form-item>
            <el-form-item label="Distance in miles">
                <el-input-number v-model="formData.radius"
                                 :disabled="processing"
                                 :step="1"
                                 :min="0"
                                 style="width:100%"/>
            </el-form-item>
        </el-form>

        <el-alert v-if="errorMessage !== null" title="Error: " type="error" :closable="false">
            {{ errorMessage }}
        </el-alert>

        <span slot="footer" class="dialog-footer">
            <el-button :disabled="processing" @click="$emit('update:openDialog', false)">Cancel</el-button>
            <el-button :disabled="processing" :type="eraseModeOn ? 'danger' : 'success'" @click="process">
                <i v-if="processing" class="fa fa-pulse fa-spinner"></i> {{ eraseModeOn ? 'Remove' : 'Add' }}
            </el-button>
        </span>

    </el-dialog>
</template>

<script>
    export default {
        props: {
            areaId: { type: Number, required: true },
            openDialog: { type: Boolean, required: true },
            eraseModeOn: { type: Boolean, required: true },
            mapUrl: { type: Function, required: true }
        },
        data() {
            return {
                formData: {
                    zipCode: '',
                    radius: 50,
                },
                processing: false,
                errorMessage: null,
            };
        },
        methods: {
            process() {
                this.processing = true;
                this.errorMessage = null;

                axios.post(this.url(`admin/area/add-zip-radius`),
                    _.merge(this.formData, { area_id: this.areaId, is_exclusion: this.eraseModeOn }))
                    .then(response => {
                        if (typeof response.data.error !== 'undefined') {
                            this.errorMessage = response.data.error;
                        } else {
                            this.$set(this.formData, 'zipCode', '');
                            this.$set(this.formData, 'radius', 50);
                            this.$emit('process');
                            this.$emit('update:openDialog', false);
                        }
                    })
                    .finally(() => { this.processing = false; });
            },
        },
    };
</script>